import {useMemo} from 'react';

import {useDispatch} from 'react-redux';

import {
  setCurrentModal,
} from '~/shared/store/actions';
import {MoneyCard} from '~/shared/services/bffService/api/interfaces/responses';

import useCancelMoneycard from './useCancelMoneycard';

const useMyTenbisActions = ({currentMoneycard}: {currentMoneycard: MoneyCard | null}) => {
  const dispatch = useDispatch();
  const {onClick: onClickCancelCard} = useCancelMoneycard({currentMoneycard});

  return useMemo(() => (!currentMoneycard ? [] : [
    {
      key: 'link_credit_card',
      caption: 'link_credit_card_to_10bis',
      onClick: () => {},
    },
    {
      key: 'billing_permissions',
      caption: 'manage_billing_permissions',
      onClick: () => {
        dispatch(setCurrentModal('billingPermissions', {moneycardId: currentMoneycard.id}));
      },
    },
    ...(!currentMoneycard.isWalletCard ? [
      {
        key: 'card_lost_or_stolen',
        caption: 'card_lost_or_stolen',
        onClick: () => {
          dispatch(setCurrentModal('reIssueOrReplaceMoneycard', {moneycardId: currentMoneycard.id, isReIssue: false}));
        },
      },
      {
        key: 'card_worn_or_not_working',
        caption: 'card_worn_or_not_working',
        onClick: () => {
          dispatch(setCurrentModal('reIssueOrReplaceMoneycard', {moneycardId: currentMoneycard.id, isReIssue: true}));
        },
      },
      {
        key: 'cancel_card',
        caption: 'cancel_10bis_card',
        onClick: onClickCancelCard,
      },
    ] : []),
  ]), [currentMoneycard, dispatch, onClickCancelCard]);
};

export default useMyTenbisActions;
